module.exports = __webpack_public_path__ + "78e3ab707aa7f2a70958b01b0d6b7525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/bandeau-smallest.jpg
// module id = 30
// module chunks = 0